import { Component, OnInit,ViewChild,ViewContainerRef } from '@angular/core';
import { DataService } from '../../shared/services/dataService';
 
import { HttpClient } from '@angular/common/http';
import { Router } from "@angular/router";
import { AuthService } from '../../shared/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { NgTableColumn, NgTableFormat } from 'src/app/components/forms/ng-table.inferface';
import { NgTableComponent } from 'src/app/components/forms/ng-table.component';
 

@Component({
    selector: 'app-general-component',
    templateUrl: './general.component.html'
})

export class GeneralComponent  implements OnInit{

  request: DataService;
  permission: any = {};
  data:any;
  @ViewChild(NgTableComponent) table: NgTableComponent;
  
  constructor(
      private toastr: ToastrService,
      private http: HttpClient,
      private router: Router,
      private service: DataService,
      private authService: AuthService
    ) {
        
  }
 
  ngOnInit() {
 
     this.permission =   this.authService.getPermission(this.router.url);
     
  }
 
  
  public datasource = (params: any): Observable<any> => {    
    return this.service.post(`general/list`,params);
  };

 
 
  onDelete(obj: any) {
    if (confirm("Are you sure delete this record?")) {
      this.service.delete("general/delete", obj.id)
        .subscribe(response => {
          this.table.refresh()
          this.toastr.success("Delete completed.", 'Success.');          
        },
        error => {
          this.toastr.error(error.message, 'Error!');
        });
    }
  }
  onEdit(e) {
    this.router.navigate(['/setup/general/editing/'+e.id]);
  }
 

  public columns: Array<NgTableColumn> = [  
    { title: 'Type', name: 'typeCode', sort: true },
    { title: 'Code', name: 'code', sort: true },
    { title: 'Name', name: 'name', sort: true },    
    { title: 'CreateDate', name: 'createDate',width: '20%',format: NgTableFormat.DateTime,},
    { title: 'Crerated',align:'center', name: 'isActive',width: '10%',sort: false,},
    { template: 'action',width: '10%',sort: false,},
  ];
}
